module.exports = __webpack_public_path__ + "img/logo_fixed.9ab96d98.png";